import {useState, useEffect} from 'react'
type ScreenSize = {
    width: number;
    height: number;
    isSmall: boolean;
    isMedium: boolean;
    isLarge: boolean;
}

// const sizeSM = 576;
const sizeMD = 768;
const sizeLG =  992;


export default function useScreenSize(): ScreenSize {
    const [screenSize, setScreenSize] = useState<ScreenSize>({
        width: window.innerWidth,
        height: window.innerHeight,
        isLarge: window.innerWidth >= sizeLG,
        isMedium: window.innerWidth >= sizeMD,
        isSmall: window.innerWidth < sizeMD,
    });

    useEffect(() => {
        const handleResize = () => {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight,
                isLarge: window.innerWidth >= sizeLG,
                isMedium: window.innerWidth >= sizeMD,
                isSmall: window.innerWidth < sizeMD,
            });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return screenSize;

}
